import Repository from '../../repositories/RepositoryFactory';
const ccmConsentFormRepository = Repository.get('ccmConsentForms');

export default {
	namespaced: true,
	state: {
		ccmConsentFormByPatientId: [],
		ccmConsentForm: null,
	},
	mutations: {
		STORE_CCM_CONSENT_FORM_BY_PATIENT_ID (state, payload) {
			state.ccmConsentFormByPatientId = payload;
		},
		STORE_CCM_CONSENT_FORM (state, payload) {
			state.ccmConsentForm = payload;
		},
		REMOVE_CCM_CONSENT_FORM (state, id) {
			state.ccmConsentFormByPatientId = state.ccmConsentFormByPatientId.filter((consentForm) => consentForm.id !== id);
		},
	},
	actions: {
		async getAllCCMConsentFormByPatientId ({ commit }, patientId) {
			const response = await ccmConsentFormRepository.getAllCCMConsentFormByPatientId(patientId);
			commit('STORE_CCM_CONSENT_FORM_BY_PATIENT_ID', response.data);
		},

		async getSingleCCMConsentFormByPatientId ({ commit }, request) {
			const response = await ccmConsentFormRepository.getSingleCCMConsentFormByPatientId(
				request.patientId,
				request.consentFormId,
			);
			commit('STORE_CCM_CONSENT_FORM', response.data);
		},

		async getCCMConsentForm ({ commit }, id) {
			const response = await ccmConsentFormRepository.getCCMConsentForm(id);
			return response;
		},

		async addCCMConsentForm ({ commit }, body) {
			return await ccmConsentFormRepository.addCCMConsentForm(body);
		},

		async deleteCCMConsentForm ({ commit }, id) {
			commit('REMOVE_CCM_CONSENT_FORM', id);
			return await ccmConsentFormRepository.deleteCCMConsentForm(id);
		},
	},
};
